import script from "./ElementPositionPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementPositionPanel.vue?vue&type=script&lang=ts&setup=true"

import "./ElementPositionPanel.vue?vue&type=style&index=0&id=08d61819&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d61819"]])

export default __exports__